export const REDUCER_NAME = 'auth';
